/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientAttributesRest
 */
export interface ClientAttributesRest {
    /**
     * 
     * @type {string}
     * @memberof ClientAttributesRest
     */
    name?: string;
     /**
     * 
     * @type {string}
     * @memberof ClientAttributesRest
     */
      nameLng?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAttributesRest
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAttributesRest
     */
    valueOriginal?: string;
}

export function ClientAttributesRestFromJSON(json: any): ClientAttributesRest {
    return ClientAttributesRestFromJSONTyped(json, false);
}

export function ClientAttributesRestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientAttributesRest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'nameLng': !exists(json, 'nameLng') ? undefined : json['nameLng'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'valueOriginal': !exists(json, 'valueOriginal') ? undefined : json['valueOriginal'],
    };
}

export function ClientAttributesRestToJSON(value?: ClientAttributesRest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'nameLng': value.nameLng,
        'code': value.code,
        'valueOriginal': value.valueOriginal,
    };
}


